import { Flex, Text } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import { LightPageContainer } from '../styles'

const PageLoading: React.FC = () => {
  const { t } = useTranslation()

  return (
    <LightPageContainer>
      <Flex flex="1" justifyContent="center" alignItems="center">
        <Text color="black">{t('Loading ...')}</Text>
      </Flex>
    </LightPageContainer>
  )
}

export default PageLoading
